import { Component, OnInit, ViewChild } from '@angular/core';
import { MCPlanningMaterialService } from '../../Services/MCPlanningMaterial/mcplanningmaterial.service'
import {WHStockInService} from '../../Services/whstock-in/whstockin.service'
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component'
import { PagerService } from '../../Services/pager.service'
import { IDropdownSettings } from 'ng-multiselect-dropdown'
import { productionFilter, productionDetails,productionDetails_ByPoNumer, ProductionStatus } from "../../Models/Production/production"
import { DatePipe } from '@angular/common';
import { DebugHelper } from 'protractor/built/debugger';
import { Router } from '@angular/router';
import { MatDatepickerInputEvent } from '@angular/material';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-production-printing',
  templateUrl: './production-printing.component.html',
  styleUrls: ['./production-printing.component.css'],
  providers: [PagerService, DatePipe]
})


export class ProductionPrintingComponent implements OnInit {

  @ViewChild('RMHName') RMHName;
  @ViewChild('Brand') Brand;
  @ViewChild('requirementStatus') requirementStatus;
  @ViewChild('JobNumber') JobNumber;
  @ViewChild('State') State;
  @ViewChild('vendorType') vendorType;
  userID: string;
  roleID: string;
  CNNNumber: any='';
  requirementStatusId :number;
  StockInDate: any=new Date();;
  StockInQuantity: any=0;
  NumberofBoxes: any=0;
  Logistics: any='';
  DocketNumber: any='';
  EstimatedDeliveryDate:any =new Date();
  VendorName:string='';
  BalanceQuantity:any=0;
  InvoiceNumber: any='';
  InvoiceDate: any= new Date();
  InvoiceValue: any=0;
  PaymentDate: any=new Date();;
  Remarks: any='';
  DispatchedDate:any=new Date();
  displayEditPanel:string='none';
  displayViewPanel:string='none';
  selectCheck: boolean = false;
  poNumber:string='';
  approvedQuantity='';
  rmhName:string='';
  jobNumber:string='';
  ascNumberSort: boolean = true;
  sortDirection: string = '';
  poQuantity:any=0;
  files: File[] = [];
  fileName: string = '';
  selectModule: string;
  fileNameParts: string[];
  fileType: string;
  loader: string = 'none';
  selectedRMHName: string = '';
  selectedJobType: string = '';
  selectedBrand: string = '';
  selectedCrop: string = '';
  selectedLanguage: string = '';
  selectedMonth: string = '';
  selectedStatus:string='';
  selectedYear: string = '';
  selectedState:string='';
  selectedJobNumber:string='';
  selectedListVendor:string='';
  status: any;
  requirementId: string = '';
  additionalrequirementId: string = '';
  displayStatusPanel: string = 'none';
  productionStatus: ProductionStatus[] = [];
  statusIntegrate: ProductionStatus = new ProductionStatus();
  selectStatus: any;
  //Multiple dropdown select
  dropdownMonth = [];
  dropdownStatus=[];
  selectedItems = [];
  dropdownSettings: IDropdownSettings = {};
  dropdownCropSettings: IDropdownSettings = {};
  dropdownBrandSettings: IDropdownSettings = {};
  dropdownJobTypeSettings: IDropdownSettings = {};
  dropdownLanguageSettings: IDropdownSettings = {};
  dropdownRmhsSettings: IDropdownSettings = {};
  dropdownstatusSettings: IDropdownSettings = {};
  dropdownJobNumbersSetting:IDropdownSettings={};
  dropdownstateSetting:IDropdownSettings={};
  dropdownVendorSettings:IDropdownSettings={};
  yearSettings : IDropdownSettings = {};
  @ViewChild('file') input;
  @ViewChild('year') year;
  productionFilters: productionFilter = new productionFilter();
  productionDetails: productionDetails[] = [];
  proddetails:productionDetails_ByPoNumer =null;

  SubmitProductionDetails:boolean=true;

  displayArtworkEditPanel:string='none';

  /* Added for 15.01.2021*/
  ArtworkToPrinter:Date;
  Artworkjpeg:Date;
  proofApproveDate:Date;
  proofApprover:any;
  Status:any;

  // /* Added For Error Panel in excel upload 17 jun 21 */
  displayUploadErrorPanel:string='none';

  constructor(private mcPlanningMaterialService: MCPlanningMaterialService,private wHStockInService: WHStockInService, private router: Router,
     private datePipe: DatePipe,private snackBar: MatSnackBarComponent,private toastr: ToastrService) {
    this.roleID = localStorage.getItem('mcmt_roleID');
    this.userID = localStorage.getItem('mcmt_userId');
    this.selectModule = "Printing";
    this.selectStatus=7;
  }

  bindMonthDropdown() {
    this.dropdownMonth = [
      { item_id: 1, item_text: 'January' },
      { item_id: 2, item_text: 'February' },
      { item_id: 3, item_text: 'March' },
      { item_id: 4, item_text: 'April' },
      { item_id: 5, item_text: 'May' },
      { item_id: 6, item_text: 'June' },
      { item_id: 7, item_text: 'July' },
      { item_id: 8, item_text: 'August' },
      { item_id: 9, item_text: 'September' },
      { item_id: 10, item_text: 'October' },
      { item_id: 11, item_text: 'November' },
      { item_id: 12, item_text: 'December' }
    ];

    this.dropdownStatus = [
      { item_id: 5, item_text: 'Artwork Required' },
      { item_id: 6, item_text: 'Production In Process' },
      { item_id: 7, item_text: 'Dispatched by Printer' },
      { item_id: 15, item_text: 'Artwork Approval Awaited' },
      { item_id: 16, item_text: 'Printer to Share JPEG' },
    ];

    
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true

    };
  }
  bindDropdown() {
    this.dropdownCropSettings = {
      singleSelection: false,
      idField: 'cropID',
      textField: 'cropName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true

    };
    this.dropdownBrandSettings = {
      singleSelection: false,
      idField: 'brandName',
      textField: 'brandName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true

    };
    this.dropdownJobTypeSettings = {
      singleSelection: false,
      idField: 'jobTypeID',
      textField: 'jobTypeName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true

    };
    this.dropdownLanguageSettings = {
      singleSelection: false,
      idField: 'languageID',
      textField: 'languageName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true

    };
    this.dropdownRmhsSettings = {
      singleSelection: false,
      idField: 'rMHCode',
      textField: 'rMHName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true
    };
    this.dropdownstatusSettings={
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true
    };
    this.dropdownJobNumbersSetting={
      singleSelection: false,
      idField: 'jobNumber',
      textField: 'jobNumber',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true
    };
    this.dropdownstateSetting={
      singleSelection: false,
      idField: 'stateID',
      textField: 'stateName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true
    };
    this.dropdownVendorSettings = {
      singleSelection: false,
      idField: 'vendorId',
      textField: 'vendorType',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true
    };
    this.yearSettings = {
      singleSelection: true,
      idField: 'year',
      textField: 'year',
      enableCheckAll: false,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: false,
      limitSelection: -1,
      clearSearchFilter: false,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Year Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  onItemSelect(event: any, filter: string) {
    if (filter == "Month") {
      this.selectedMonth += event.item_id + ',';

    }
    // if (filter == "RMH") {
    //   if (this.selectedRMHName.lastIndexOf(',') != this.selectedRMHName.length-1) {
    //     this.selectedRMHName += ','+ "'" + event.rMHCode + "'" + ',';
    //   }
    //   else {
    //     this.selectedRMHName += "'" + event.rMHCode + "'" + ',';
    //   }

    // }
    if (filter == "Crop") {
      this.selectedCrop += event.cropID + ',';

    }
    // if (filter == "Brand") {
    //   this.selectedBrand += "'" + event.brandName + "'" + ',';

    // }
    if (filter == "Language") {
      this.selectedLanguage += event.languageID + ',';

    }
    if (filter == "Jobtype") {
      this.selectedJobType += event.jobTypeID + ',';

    }
  }
  onSelectAll(event: any, filter: string) {

    if (filter == "Month") {
      this.selectedMonth = '';
      for (let item of event) {
        this.selectedMonth += item.item_id.toString() + ',';
      }

    }
    // if (filter == "RMH") {
    //   this.selectedRMHName = '';
    //   for (let item of event) {
    //     this.selectedRMHName += "'" + item.rMHCode.toString() + "'" + ',';
    //   }

    // }
    if (filter == "Crop") {
      this.selectedCrop = '';
      for (let item of event) {
        this.selectedCrop += item.cropID.toString() + ',';
      }

    }
    // if (filter == "Brand") {
    //   this.selectedBrand = '';
    //   for (let item of event) {
    //     this.selectedBrand += "'" + item.brandName.toString() + "'" + ',';
    //   }

    // }
    if (filter == "Language") {
      this.selectedLanguage = '';
      for (let item of event) {
        this.selectedLanguage += item.languageID.toString() + ',';
      }

    }
    if (filter == "Jobtype") {
      this.selectedJobType = '';
      for (let item of event) {
        this.selectedJobType += item.jobTypeID.toString() + ',';
      }

    }
  }
  deSelectAll(event: any, filter: string) {
    if (filter == "Month")
      this.selectedMonth = '';
    // if (filter == "RMH")
    //   this.selectedRMHName = '';
    if (filter == "Jobtype")
      this.selectedJobType = '';
    // if (filter == "Brand")
    //   this.selectedBrand = '';
    if (filter == "Crop")
      this.selectedCrop = '';
    if (filter == "Language")
      this.selectedLanguage = '';
  }
  unSelect(event: any, filter: string) {
    switch (filter) {
      case "Month":
        {
          if (this.selectedMonth.indexOf(event.item_id + ',') != -1) {
            this.selectedMonth = this.selectedMonth.replace(event.item_id + ',', '');
          }
          else {
            this.selectedMonth = this.selectedMonth.replace(event.item_id, '');
          }
          break;
        }
      // case "RMH":
      //   {
      //     if (this.selectedRMHName.indexOf("'" + event.rMHCode + "'" + ',') != -1) {
      //       this.selectedRMHName = this.selectedRMHName.replace("'" + event.rMHCode + "'" + ",", '');
      //     }
      //     else {
      //       this.selectedRMHName = this.selectedMonth.replace("'" + event.rMHCode + "'", '');
      //     }
      //     break;
      //   }
      case "Jobtype":
        {
          if (this.selectedJobType.indexOf(event.jobTypeID + ',') != -1) {
            this.selectedJobType = this.selectedJobType.replace(event.jobTypeID + ',', '');
          }
          else {
            this.selectedJobType = this.selectedJobType.replace(event.jobTypeID, '');
          }
          break;
        }
      // case "Brand":
      //   {
      //     if (this.selectedBrand.indexOf("'" + event.brandName + "'" + ',') != -1) {
      //       this.selectedBrand = this.selectedBrand.replace("'" + event.brandName + "'" + ",", '');
      //     }
      //     else {
      //       this.selectedBrand = this.selectedBrand.replace("'" + event.brandName + "'", '');
      //     }
      //     break;
      //   }
      case "Crop":
        {
          if (this.selectedCrop.indexOf(event.cropID + ',') != -1) {
            this.selectedCrop = this.selectedCrop.replace(event.cropID + ',', '');
          }
          else {
            this.selectedCrop = this.selectedCrop.replace(event.cropID, '');
          }
          break;
        }
      case "Language":
        {
          if (this.selectedLanguage.indexOf(event.languageID + ',') != -1) {
            this.selectedLanguage = this.selectedLanguage.replace(event.languageID + ',', '');
          }
          else {
            this.selectedLanguage = this.selectedLanguage.replace(event.languageID, '');
          }
          break;
        }
      default:
    }
  }
  ProductionPrintingfilter() {

    this.loader = 'block';
    this.mcPlanningMaterialService.getProductionFilter('Printing')
      .subscribe((responsedata: any) => {
        if (responsedata.status == true) {
          this.productionFilters = responsedata.data;
          class YearItemList{
            id: string;
            text: string;
        }
          let requiredItem: YearItemList[] = [];
          var obj = {
            id : this.productionFilters.currentRequirementYear[0].currentrequirementYear,
            text: this.productionFilters.currentRequirementYear[0].currentrequirementYear
          }
          requiredItem.push(obj)
          this.year.selectedItems = requiredItem;
          this.loader = 'none';
          this.GetProductionDetails();
        }
        else {
          this.productionFilters = responsedata.data;
          class YearItemList{
            id: string;
            text: string;
          }
          let requiredItem: YearItemList[] = [];
          var obj = {
            id : this.productionFilters.currentRequirementYear[0].currentrequirementYear,
            text: this.productionFilters.currentRequirementYear[0].currentrequirementYear
          }
          requiredItem.push(obj)
          this.year.selectedItems = requiredItem;
          this.loader = 'none';
          this.GetProductionDetails();
        }
      })
  }

  onYearSelect(item: any) {
    let selectedyear = this.year.selectedItems[0].id;
    
    if(selectedyear != this.productionFilters.currentRequirementYear[0].currentrequirementYear)
    {     
      var someElement= document.getElementById("ancUploadExcel"); 
      someElement.className += "hideuploadExcel";
    }
    else
    {
      document.getElementById("ancUploadExcel").classList.remove("hideuploadExcel");
    }
  }

  GetProductionDetails() {
    this.selectCheck = false;
    this.selectedRMHName = Array.prototype.map.call(this.RMHName.selectedItems, function (item) { return ""+ item.id+""; }).join(",");// this.selectedRMHName.lastIndexOf(",") == this.selectedRMHName.length - 1 ? this.selectedRMHName.substring(0, this.selectedRMHName.lastIndexOf(",")) : this.selectedRMHName;
    this.selectedMonth = this.selectedMonth.lastIndexOf(',') == this.selectedMonth.length - 1 ? this.selectedMonth.substring(0, this.selectedMonth.length - 1) : this.selectedMonth;
    this.selectedCrop = this.selectedCrop.lastIndexOf(",") == this.selectedCrop.length - 1 ? this.selectedCrop.substring(0, this.selectedCrop.length - 1) : this.selectedCrop;
    this.selectedBrand = Array.prototype.map.call(this.Brand.selectedItems, function (item) { return ""+ item.id+""; }).join(",");//this.selectedBrand.lastIndexOf(",") == this.selectedBrand.length - 1 ? this.selectedBrand.substring(0, this.selectedBrand.lastIndexOf(",")) : this.selectedBrand;
    this.selectedLanguage = this.selectedLanguage.lastIndexOf(",") == this.selectedLanguage.length - 1 ? this.selectedLanguage.substring(0, this.selectedLanguage.length - 1) : this.selectedLanguage;
    this.selectedJobType = this.selectedJobType.lastIndexOf(",") == this.selectedJobType.length - 1 ? this.selectedJobType.substring(0, this.selectedJobType.length - 1) : this.selectedJobType;
    this.selectedStatus=Array.prototype.map.call(this.requirementStatus.selectedItems, function (item) { return  item.id; }).join(",");
    if(this.selectedStatus.length==0)
    this.selectedStatus = '5,6,7,8,9,10';
    this.selectedJobNumber=Array.prototype.map.call(this.JobNumber.selectedItems, function (item) { return ""+ item.id+""; }).join(",");
    this.selectedState=Array.prototype.map.call(this.State.selectedItems, function (item) { return ""+ item.id+""; }).join(",");
    this.selectedListVendor=Array.prototype.map.call(this.vendorType.selectedItems, function (item) { return ""+item.id+""; }).join(",");
    this.selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.mcPlanningMaterialService.GetProductionPrintingDetails(this.selectedRMHName, this.selectedJobType, this.selectedBrand, this.selectedCrop, this.selectedLanguage, this.selectedMonth, this.selectedStatus, this.selectedJobNumber,this.selectedState,this.selectedListVendor, this.selectedYear)
      .subscribe((responseData: any) => {
        if (responseData.status == true) {
          this.productionDetails = responseData.data;
          this.loader = 'none';
        }
        else {
          this.productionDetails = responseData.data;
          this.toastr.error('No record Available');
          this.loader = 'none';
        }
      })

  }
  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.ProductionPrintingfilter()
    this.bindMonthDropdown();
    this.bindDropdown();
    this.bindProductionStatus();
    
  }
  GetcheckedItem() {
    this.requirementId='';
    this.additionalrequirementId='';

    this.productionDetails.forEach(element => {
      if (this.selectCheck == false)
      {
        if(element.requirementType==1 && (element.status=='Production In Process'))
        this.requirementId += element.isSelected == undefined || element.isSelected == false ? "" : element.requirementDetailsID + ",";
        else
        if(element.status=='Production In Process' )
        this.additionalrequirementId+= element.isSelected == undefined || element.isSelected == false ? "" : element.requirementDetailsID + ",";
      }
      else
        if(element.requirementType==1  && (element.status=='Production In Process' ))
        this.requirementId += element.requirementDetailsID + ",";
        else
        if(element.status=='Production In Process')
        this.additionalrequirementId+=  element.requirementDetailsID + ",";
    });
    if (this.requirementId.trim().length > 0 || this.additionalrequirementId.trim().length > 0)
      this.submitProductionStatus();
      else
      this.toastr.error('Please check any record/s to Approve');
  }
  checkSelected(index: number) {
    if (!this.productionDetails[index]["isSelected"]) {
      if(this.productionDetails[index]["requirementType"]==1 && (this.productionDetails[index]["status"]=='Production In Process' ))
      this.requirementId.trim().replace(this.productionDetails[index]["requirementDetailsID"] + ',', '');
      else
      if(this.productionDetails[index]["status"]=='Production In Process' )
      this.additionalrequirementId.trim().replace(this.productionDetails[index]["requirementDetailsID"] + ',', '');
      this.selectCheck = false;
    }
  }

  selectedDisable(index: number){
    if(this.productionDetails[index]["status"]=='Production In Process'){
      return 'false';
    }
    else{
      return 'true';
    }
  }
  SelectAll() {
    this.productionDetails.forEach(element => {
      if (this.selectCheck == true && (element.status=='Production In Process' ))
        element.isSelected = true;
      else {
        if(element.status=='Production In Process')
        element.isSelected = false;
        this.requirementId = "";
        this.additionalrequirementId = "";
      }
    })
  }
  ChangeModule() {
    this.GetProductionDetails();
    this.ProductionPrintingfilter();
    this.bindProductionStatus();
    this.selectCheck = false;
  }
  closeStatusPanel() {
    this.displayStatusPanel = 'none';
    this.requirementId = '';
  }
  bindProductionStatus() {
    this.productionStatus = [];
  // for (let i = 1; i <= 2; i++) {

     // if (i == 1) {
        if (this.selectModule == "Printing") {
          this.statusIntegrate = new ProductionStatus();;
          this.statusIntegrate.StatusID = 5;
          this.statusIntegrate.StatusName = "Artwork Required";
          this.statusIntegrate = new ProductionStatus();;
          this.statusIntegrate.StatusID = 6;
          this.statusIntegrate.StatusName = "Production in process";
          this.productionStatus.push(this.statusIntegrate)
          this.statusIntegrate = new ProductionStatus();;
          this.statusIntegrate.StatusID = 7;
          this.statusIntegrate.StatusName = "Printing Done";
          this.productionStatus.push(this.statusIntegrate)
        }
        else {
          this.statusIntegrate = new ProductionStatus();;
          this.statusIntegrate.StatusID = 7;
          this.statusIntegrate.StatusName = "Production in process";
          this.productionStatus.push(this.statusIntegrate)
          this.statusIntegrate = new ProductionStatus();;
          this.statusIntegrate.StatusID = 8;
          this.statusIntegrate.StatusName = "Packageing Done";
          this.productionStatus.push(this.statusIntegrate)
        }
   //   }
      // else {
      //   if (this.selectModule == "Printing") {
      //     this.statusIntegrate.StatusID = 11;
      //     this.statusIntegrate.StatusName = "Printing Done";
      //   }
      //   else {
      //     this.statusIntegrate.StatusID = 13;
      //     this.statusIntegrate.StatusName = "Packageing Done";
      //   }
      // }
 //   }
  }
  submitProductionStatus()
  {
    this.loader='block';
    this.mcPlanningMaterialService.UpdateProductionStatus(this.requirementId,this.selectStatus,this.additionalrequirementId)
    .subscribe((responseData: any) => {
      if (responseData.status) {
        if(responseData.data.length>0)
        {
          this.toastr.error('Please Complete Production Update step for Job Number '+responseData.data);

        }
        else
        {
          this.toastr.success('Status Updated Successfully');

        }
        this.loader = 'none';
        this.displayStatusPanel='none';
        this.GetProductionDetails();
      }
      else {
        this.toastr.error('Some error Occured,Could not update status');
        this.loader = 'none';
        this.displayStatusPanel='none';
        this.GetProductionDetails();
      }
    })
  }
  changeStatus(details:any)
  {
    if(this.selectModule == "Printing")
    {
      this.selectStatus=7;
    }
    else
    this.selectStatus=8;
    if(details.requirementType=="1")
    this.requirementId=details.requirementDetailsID
    else
    this.additionalrequirementId=details.requirementDetailsID
 
    this.submitProductionStatus();
  }
  viewPanel(poNumber:any,StatusID : any,defination:string)
  {
    this.requirementStatusId = StatusID;
    this.CNNNumber='';
    this.VendorName='';
    this.DispatchedDate=new Date();
    this.Logistics='';
    this.NumberofBoxes=0;
    this.PaymentDate=new Date();
    this.DocketNumber='';
    this.InvoiceValue='';
    this.Remarks='';
    this.InvoiceNumber='';
    this.InvoiceDate=new Date();
    this.EstimatedDeliveryDate=new Date();
    this.poNumber=poNumber;
    this.displayEditPanel='block';    
    this.displayViewPanel='block';
    // this.ArtworkPrinter=new Date();
    // this.Jpegdate=new Date();
    // this.proofApprovedDate=new Date();
    // this.Approver='';
    //this.displayStatusPanel='block';
    this.mcPlanningMaterialService.GetProductionPrintingDetails_ByPoNumber(poNumber)
      .subscribe((responseData: any) => {
        if (responseData.status == true) {
          this.proddetails = responseData.data;
          this.poNumber=this.proddetails[0].poNumber;
          this.rmhName=this.proddetails[0].rmhName;
          this.jobNumber=this.proddetails[0].jobNumber;
          this.approvedQuantity=this.proddetails[0].approvedQuantity;
          this.poQuantity=this.proddetails[0].poQuantity;
          this.CNNNumber = this.proddetails[0].cnNumber;
          this.VendorName = this.proddetails[0].vendorName;
          this.DispatchedDate = this.proddetails[0].dipatchDate;
          this.PaymentDate = this.proddetails[0].paymentDate;
          this.DocketNumber = this.proddetails[0].docketNo;
          this.InvoiceValue = this.proddetails[0].invoiceValue;
          this.Remarks = this.proddetails[0].remarks;
          this.InvoiceNumber = this.proddetails[0].invoiceNo;
          this.InvoiceDate = this.proddetails[0].invoiceDate;
          this.EstimatedDeliveryDate = this.proddetails[0].warehouseDate;
          this.ArtworkToPrinter=this.proddetails[0].artworkGivenToPrinter;
          this.Artworkjpeg=this.proddetails[0].printerSharedJpeg;
          this.proofApproveDate=this.proddetails[0].proofApproved;
          this.proofApprover=this.proddetails[0].proofApproverName;   
          this.loader = 'none';
          //this.GetProductionSavedDetails(this.jobNumber,this.poNumber);
        }
        // else {
        //   this.productionDetails = responseData.data;
        //   this.toastr.error('No records Available', 'Close', 'red-snackbar');
        //   this.loader = 'none';
        // }
      })
    if(defination=='view')
      this.SubmitProductionDetails=true;
      else
      this.SubmitProductionDetails=false;

  }
  viewArtworkPanel(poNumber:any,StatusID : any,defination:string)
  {
    this.displayArtworkEditPanel='block';    
    this.displayViewPanel='block';
    this.mcPlanningMaterialService.GetProductionPrintingDetails_ByPoNumber(poNumber)
    .subscribe((responseData: any) => {
      if (responseData.status == true) {
        this.proddetails = responseData.data;
        this.poNumber=this.proddetails[0].poNumber;
        this.rmhName=this.proddetails[0].rmhName;
        this.jobNumber=this.proddetails[0].jobNumber;
        this.approvedQuantity=this.proddetails[0].approvedQuantity;   
         this.ArtworkToPrinter=this.proddetails[0].artworkGivenToPrinter==null && StatusID=='Artwork Required'?'mm/DD/yyyy':this.proddetails[0].artworkGivenToPrinter;
         this.Artworkjpeg=this.proddetails[0].printerSharedJpeg==null && StatusID=='Printer to Share JPEG'?'mm/DD/yyyy':this.proddetails[0].printerSharedJpeg;
         this.proofApproveDate=this.proddetails[0].proofApproved==null && StatusID=='Artwork Approval Awaited'?'mm/DD/yyyy':this.proddetails[0].proofApproved;
         this.proofApprover=this.proddetails[0].proofApproverName;    
         this.Status=StatusID;
      }
    });

  }
  GetProductionSavedDetails(JobNumber:any,POnumber: any){
    this.wHStockInService.getProductionSavedDetails(JobNumber,'', '', '', '', '', '', '', POnumber)
    .subscribe((resdata: any) => {
      this.loader = 'block';
      if (resdata.status == true) {
        if(resdata.data.length>0)
        {
       // this.details = resdata.data.warehouseStockInDetail;
        //alert(resdata.data[0].invoiceDate);
      this.DispatchedDate=new Date(resdata.data[0].dispatchDate);//resdata.data[0].dispatchDate;
        this.CNNNumber=resdata.data[0].cnNumber;
        // this.StockInDate=resdata.data.warehouseStockInDetail[0].stockInDate;
        // this.StockInQuantity=resdata.data.warehouseStockInDetail[0].stockInQty;
        //this.NumberofBoxes=resdata.data[0].noOfBoxes;
        //this.Logistics=resdata.data[0].logistics;
        this.DocketNumber=resdata.data[0].docketNo;
        this.InvoiceNumber=resdata.data[0].invoiceNo;
        this.InvoiceDate=new Date(resdata.data[0].invoiceDate);//this.datePipe.transform(resdata.data[0].invoiceDate,"MM/dd/yyyy");
        this.InvoiceValue=resdata.data[0].invoiceValue;
        this.Remarks=resdata.data[0].remarks;
        this.VendorName=resdata.data[0].vendor;
        this.PaymentDate =new Date(resdata.data[0].paymentDate);
        this.EstimatedDeliveryDate=new Date(resdata.data[0].estimatedDelivery);

        if(this.InvoiceDate=="")
        {
         // this.StockInDate =this.datePipe.transform(new Date(),"dd-MM-yyyy");
         this.InvoiceDate =new Date();
        }
        if(this.PaymentDate=="")
        {
         // this.StockInDate =this.datePipe.transform(new Date(),"dd-MM-yyyy");
         this.PaymentDate =new Date();
        }
        this.displayEditPanel = 'block';
       // this.getsaveSubmitStatus();
        this.loader = 'none';          
      }
      this.loader = 'none';
      }
      else {
        this.toastr.error(resdata.msg);
        this.loader = 'none';
      }
    });
  }
  

  DraftSave(Type:number) {
   
    // if( this.CNNNumber=='undefined' || this.CNNNumber.length==0)
    // {
    //   this.toastr.error('Please Enter CN Number', 'Close', 'red-snackbar');
    //   return false;
    // }
    // if( this.VendorName=='undefined' || this.VendorName.length==0)
    // {
    //   this.toastr.error('Please Enter forwarder Name', 'Close', 'red-snackbar');
    //   return false;
    // }
    // if(this.NumberofBoxes<=0 ||this.NumberofBoxes=='undefined'){
    //   this.toastr.error('Number of boxes should be greater than 0', 'Close', 'red-snackbar');
    //   return false;
    // }
    // if(this.NumberofBoxes.length==0)
    // {
    //   this.toastr.error('Please Enter Number of Boxes', 'Close', 'red-snackbar');
    //   return false;
    // }
    // if(this.Logistics.length==0)
    // {
    //   this.toastr.error('Please Enter Logistics', 'Close', 'red-snackbar');
    //   return false;
    // }
    // if(this.DocketNumber.length==0)
    // {
    //   this.toastr.error('Please Enter Docket Number', 'Close', 'red-snackbar');
    //   return false;
    // }
    if(this.InvoiceNumber.length==0)
    {
      this.toastr.error('Please Enter Invoice Number');
      return false;
    }
    if(this.InvoiceDate.length==0)
    {
      this.toastr.error('Please Enter Invoice Date');
      return false;
    }
    if(this.DispatchedDate.length==0)
    {
      this.toastr.error('Please Enter Dispatched Date');
      return false;
    }
    if(this.EstimatedDeliveryDate.length==0)
    {
      this.toastr.error('Please Enter Estimated Delivery Date');
      return false;
    }
    // if(this.PaymentDate.length==0)
    // {
    //   this.toastr.error('Please Enter Payment Date', 'Close', 'red-snackbar');
    //   return false;
    // }
    
    let ConvertedInvoiceDate=this.datePipe.transform(this.InvoiceDate, 'dd-MMM-yyyy');
    let ConvertedPaymentDate=this.datePipe.transform(this.PaymentDate, 'dd-MMM-yyyy');
    let ConvertedEstimatedDeliveryDate=this.datePipe.transform(this.EstimatedDeliveryDate, 'dd-MMM-yyyy');

    let ConvertedDispatchedDate=this.datePipe.transform(this.DispatchedDate, 'dd-MMM-yyyy');

    this.wHStockInService.SubmitProductionDetails(this.jobNumber,this.poNumber,this.CNNNumber,this.VendorName,
      this.NumberofBoxes, this.Logistics, this.DocketNumber, this.InvoiceNumber, ConvertedInvoiceDate,ConvertedEstimatedDeliveryDate,ConvertedDispatchedDate, this.InvoiceValue,
      ConvertedPaymentDate,this.poQuantity ,this.Remarks,Type)
      .subscribe((resdata: any) => {
        this.loader = 'block';
        if (resdata.status == true) {
          debugger;
        //  if(resdata.message=="Please Complete PO Update first.PO not done for complete Final Quantity.")
        //  {
        //   this.toastr.error(resdata.message, 'Close', 'red-snackbar');
        //  }
        //  else{
          this.toastr.success(resdata.message);
         //}
          
          this.displayEditPanel = 'none';
          //this.getDetailsOnPageLoad();
          this.loader = 'none';
          this.GetProductionDetails();
        }
           else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
  }
  ArtworkApprovalSubmit(JobNumber:any,PONumber:any){
    debugger;
    if((this.ArtworkToPrinter!=null && this.ArtworkToPrinter.toString()=='mm/DD/yyyy') ||(this.Artworkjpeg!=null && this.Artworkjpeg.toString()=='mm/DD/yyyy') || (this.proofApproveDate!=null && this.proofApproveDate.toString()=='mm/DD/yyyy'))
    {
      this.toastr.error('Please fill the required input');
      return false;
    }
    let ConvertedArtworkToPrinter=this.datePipe.transform(this.ArtworkToPrinter, 'dd-MMM-yy');
    let ConvertedArtworkjpeg=this.datePipe.transform(this.Artworkjpeg, 'dd-MMM-yy');
    let ConvertedproofApproveDate=this.datePipe.transform(this.proofApproveDate, 'dd-MMM-yy');

    if((this.ArtworkToPrinter!=null && this.ArtworkToPrinter.toString()!='mm/DD/yyyy') && (this.Artworkjpeg!=null && this.Artworkjpeg.toString()!='mm/DD/yyyy') )
    {
      var artworrkPrinter=new Date(this.ArtworkToPrinter);
      var artworkjp=new Date(this.Artworkjpeg);
      if(artworrkPrinter>artworkjp)
      {
        this.toastr.error('Artwork given to printer date can not be greater than Printer to Shared JPEG Date ');
         return false;
      }
    }
    if((this.Artworkjpeg!=null && this.Artworkjpeg.toString()!='mm/DD/yyyy') && (this.proofApproveDate!=null && this.proofApproveDate.toString()!='mm/DD/yyyy'))
    {
      var proofApprovedD=new Date(this.proofApproveDate);
      var artworkjp=new Date(this.Artworkjpeg);
      if(artworkjp>proofApprovedD)
      {
        this.toastr.error('Printer to Shared JPEG date can not be greater than Proof Approved Date ');
         return false;
      }
    }
    if((this.ArtworkToPrinter!=null && this.ArtworkToPrinter.toString()!='mm/DD/yyyy') && (this.proofApproveDate!=null && this.proofApproveDate.toString()!='mm/DD/yyyy'))
    {
      var artworrkPrinter=new Date(this.ArtworkToPrinter);
      var artworkjp=new Date(this.Artworkjpeg);
      if(artworrkPrinter>artworkjp)
      {
        this.toastr.error('Artwork given to printer date can not be greater than Proof Approved Date ');
         return false;
      }
    }
    // const dateRegEx = new RegExp(/^\d{1,2}\.\d{1,2}\.\d{4}$/);
    // if(this.ArtworkToPrinter!=null )
    // {   
    //   if(dateRegEx.test(ConvertedArtworkToPrinter)==null)
    //   {
    //     this.toastr.error('Plese enter correct artwork printer date in MM/dd/YYYY format', 'Close', 'red-snackbar');
    //     return false;
    //   }
    // }
    // if(this.Artworkjpeg!=null )
    // {
    //   if(dateRegEx.test(ConvertedArtworkjpeg)==null)
    //   {
    //     this.toastr.error('Plese enter correct artwork jpeg date in MM/dd/YYYY format', 'Close', 'red-snackbar');
    //     return false;
    //   }
    // }
    // if(this.proofApproveDate!=null )
    // {
    //   if(dateRegEx.test(ConvertedproofApproveDate)==null)
    //   {
    //     this.toastr.error('Plese enter correct proof approve date in MM/dd/YYYY format', 'Close', 'red-snackbar');
    //   return false;
    //   }
    // }

    this.loader = 'block';

    this.mcPlanningMaterialService.updateArtworkStatus(JobNumber,PONumber,ConvertedArtworkToPrinter,ConvertedArtworkjpeg,ConvertedproofApproveDate,this.proofApprover)
      .subscribe((resdata: any) => {
       
        if (resdata.status == true) {
          debugger;
        //  if(resdata.message=="Please Complete PO Update first.PO not done for complete Final Quantity.")
        //  {
        //   this.toastr.error(resdata.message, 'Close', 'red-snackbar');
        //  }
        //  else{
          this.toastr.success(resdata.message);
         //}
          
          this.displayEditPanel = 'none';
          //this.getDetailsOnPageLoad();
          this.loader = 'none';
          this.displayArtworkEditPanel='none';
          this.GetProductionDetails();
        }
           else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })

  }
  closeEditPanel() {
    debugger;
    this.displayEditPanel = 'none';
    let SelectedStatus;
    //SelectedStatus = Array.prototype.map.call(this.status.selectedItems, function (item) { return item.id; }).join(",");
    
    
       // this.TotalRemainingQuantity = 0;
    // this.popTotalremainingqty = 0;
    // this.materialAllocation = [];
    // this.applySearchFilter();
  }
  closeArtworkEditPanel()
  {
    this.displayArtworkEditPanel='none';
  }
  sort() {
    debugger;
    let sortedArray : any[] = [];
    let splitString : any[] = [];
    if (this.ascNumberSort == true) {
      this.dropdownMonth.forEach(x => {
        this.productionDetails.forEach(element => {
          splitString = element.month.split("'");
          if (x.item_text.substring(0,3) == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = false;
      this.sortDirection = 'asc';
      this.productionDetails = sortedArray;
    }
    else {
      this.dropdownMonth.forEach(x => {
        this.productionDetails.forEach(element => {
          splitString = element.month.split("'");
          if (x.item_text.substring(0,3) == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = true;
      this.sortDirection = 'desc';
      this.productionDetails = sortedArray.reverse();
    }
  }

  filesAdd(files: File[]) {
    this.files = [];
    debugger;
    this.files = files;
    this.fileNameParts = files[0].name.split('.');
    this.fileType = files[0].name.split('.')[this.fileNameParts.length - 1];
    if (this.fileType != 'xls' && this.fileType != 'xlsx') {
      this.toastr.error('Please Select Valid File Type.');
      this.loader = 'none';
      this.input.nativeElement.value = null;
      return false;
    }
    this.loader = 'block';
    this.mcPlanningMaterialService.uploadProductionExcel(<File>this.files[0])
      .subscribe((resData: any) => {
        if (resData.status == true) {
          if (resData.data == 1) {
            this.toastr.error(resData.message);
            this.loader = 'none';
            this.input.nativeElement.value = null;
            this.GetProductionDetails();
          }
          else{ 
            if (resData.data[0].status == 'true') {
              this.GetProductionDetails();
              this.toastr.success(resData.data[0].msg);
              this.loader = 'none';
              this.input.nativeElement.value = null;
            }
            else {
              this.GetProductionDetails();
               this.displayUploadErrorPanel='none';
              this.toastr.error(resData.data[0].msg);
              this.loader = 'none';
              this.input.nativeElement.value = null;
            }           
          }
        }
        else {
          this.toastr.error('Some problem occurred, please try again later.');
          this.loader = 'none';
          this.input.nativeElement.value = null;
        }
        this.files = [];
        this.loader = 'none';
      });
    this.files = this.files;
    this.fileName = this.files[0].name;
  }

  excelDownload() {
    this.selectCheck = false;
    this.selectedRMHName = Array.prototype.map.call(this.RMHName.selectedItems, function (item) { return ""+ item.id+""; }).join(",");// this.selectedRMHName.lastIndexOf(",") == this.selectedRMHName.length - 1 ? this.selectedRMHName.substring(0, this.selectedRMHName.lastIndexOf(",")) : this.selectedRMHName;
    this.selectedMonth = this.selectedMonth.lastIndexOf(',') == this.selectedMonth.length - 1 ? this.selectedMonth.substring(0, this.selectedMonth.length - 1) : this.selectedMonth;
    this.selectedCrop = this.selectedCrop.lastIndexOf(",") == this.selectedCrop.length - 1 ? this.selectedCrop.substring(0, this.selectedCrop.length - 1) : this.selectedCrop;
    this.selectedBrand = Array.prototype.map.call(this.Brand.selectedItems, function (item) { return ""+ item.id+""; }).join(",");//this.selectedBrand.lastIndexOf(",") == this.selectedBrand.length - 1 ? this.selectedBrand.substring(0, this.selectedBrand.lastIndexOf(",")) : this.selectedBrand;
    this.selectedLanguage = this.selectedLanguage.lastIndexOf(",") == this.selectedLanguage.length - 1 ? this.selectedLanguage.substring(0, this.selectedLanguage.length - 1) : this.selectedLanguage;
    this.selectedJobType = this.selectedJobType.lastIndexOf(",") == this.selectedJobType.length - 1 ? this.selectedJobType.substring(0, this.selectedJobType.length - 1) : this.selectedJobType;
    this.selectedStatus=Array.prototype.map.call(this.requirementStatus.selectedItems, function (item) { return  item.id; }).join(",");
    if(this.selectedStatus.length==0)
    this.selectedStatus = '6,7,8,9,10,11,12';
    this.selectedJobNumber=Array.prototype.map.call(this.JobNumber.selectedItems, function (item) { return ""+ item.id+""; }).join(",");
    this.selectedState=Array.prototype.map.call(this.State.selectedItems, function (item) { return ""+ item.id+""; }).join(",");
    this.selectedListVendor=Array.prototype.map.call(this.vendorType.selectedItems, function (item) { return ""+item.id+""; }).join(",");
    this.selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.loader = 'block';
    this.mcPlanningMaterialService.GetProductionPrintingExcel(this.selectedRMHName, this.selectedJobType, this.selectedBrand, this.selectedCrop, this.selectedLanguage, this.selectedMonth, this.selectedStatus, this.selectedJobNumber,this.selectedState,this.selectedListVendor,this.selectedYear)
    .subscribe(
      success => {
        var date = new Date();
        let latest_date = this.datePipe.transform(date, 'dd-MMM-yy')
        let name = localStorage.getItem('mcmt_userName').split(' ');
        let firstname = name[0];
        let lastName = name[1];
        let cYear = this.year.selectedItems[0].id;
        let excelName = firstname + '_' + lastName + '_'+ cYear + '_Production_' + latest_date + '.xlsx';
        saveAs(success, excelName);

        this.loader = 'none';
      },
      err => {
        this.toastr.error("No Data Found.");
        this.loader = 'none';
      }
    );
  }

  closeUploadPanel()
  {
    this.displayUploadErrorPanel='none';
    this.GetProductionDetails();
  }
ConvertToCurrency(value:any)
  {
    debugger;
    var parts = value.toString().replace(',','').split(".");
    if(parts[0].length > 3){
      parts[0] = parts[0].slice(0,parts[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +','+ parts[0].slice(parts[0].length-3,parts[0].length);
    }
    return parts.join(".");
  }
}